import { useHistory } from 'react-router-dom';

import './Action.css';

const ActionPage: React.FC = () => {
  const history = useHistory<any>();

  const buttonCn = 'flex-1 h-40 md:h-48 p-4';
  return (
    <div className="action-background">
      <div className="absolute left-0 right-0 px-4 transform -translate-y-1/2 xl:left-48 xl:px-0 top-1/2">
        <div className="flex-col justify-between mx-auto space-y-8 xl:flex xl:flex-row ">
          <div
            role="button"
            className={buttonCn}
            onClick={() => history.push('/poll/create')}
          >
            <div className="create-poll-button" />
          </div>
          <div
            role="button"
            className={buttonCn}
            onClick={() => history.push('/feed')}
          >
            <div className="vote-button" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionPage;
